export default [
    {
        path: '/',
        name: '净慈寺'
    },
    /*{
        name: '关于净慈',
        path: '/about',
        children: [
            {
                path: 'historic',
                name: '古往今来'
            },
            {
                path: 'position',
                name: '四方上下'
            },
            {
                path: 'former',
                name: '历代祖师',
            }
        ]
    },
    {
        name: '净慈动态',
        path: '/news',
        children: [
            {
                path: 'buddhism',
                name: '法讯法会'
            },
            {
                path: 'notice',
                name: '新闻通告'
            },
            {
                path: 'charitable',
                name: '公益慈善',
            }
        ]
    },*/
    {
        name: '净慈法务',
        path: '/fawu',
        children: [
            {
                path: 'fahui',
                name: '年度法会'
            },
            {
                path: 'foshi',
                name: '日常佛事'
            },
            {
                path: 'futian',
                name: '广种福田'
            },
            {
                path: 'anyang',
                name: '愿生安养',
            }
        ]
    },
    /*{
        name: '净慈文化',
        path: '/culture',
        children: [
            {
                path: 'a',
                name: '美术馆'
            },
            {
                path: 'b',
                name: '南屏妙音'
            },
            {
                path: 'c',
                name: '南屏书社'
            },
            {
                path: 'd',
                name: '慧日峰下',
            },
            {
                path: 'e',
                name: '净慈文创',
            }
        ]
    },*/
    {
        name: '加入我们',
        path: '/join',
        children: [
            {
                path: 'recruit',
                name: '义工招募'
            }
        ]
    }
]